import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import NavBar from "../Comp/NavBar";
import Footer from "../Comp/Footer";
import ShippingModal from "../Comp/ShoppingCart/ShippingModal";

const FILE = process.env.REACT_APP_API_BASE_URL_FILE;
const resolveImg = (arr) => {
  const im = arr && arr[0] && arr[0].image;
  return im ? (/^https?:\/\//.test(im) ? im : `${FILE}/images/${im}`) : null;
};
const BoxIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round">
    <path d="M3 7l9-4 9 4v10l-9 4-9-4z" /><path d="M3 7l9 4 9-4M12 11v10" />
  </svg>
);

const ShoppingCart = () => {
  const [items, setItems] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({ title: "", firstname: "", lastname: "", country: "", city: "", address1: "", zip: "", mobile: "" });
  const navigate = useNavigate();
  const currentUser = useSelector((s) => s.currentUser);

  useEffect(() => {
    setItems(JSON.parse(localStorage.getItem("cart")) || []);
    if (!localStorage.getItem("orderID"))
      localStorage.setItem("orderID", `ORDER-${Date.now()}-${Math.floor(Math.random() * 10000)}`);
  }, []);

  const persist = (next) => { setItems(next); localStorage.setItem("cart", JSON.stringify(next)); };
  const setQty = (id, q) => persist(items.map((it) => it.id === id ? { ...it, quantity: Math.max(1, q), totalPrice: Math.max(1, q) * it.price } : it));
  const removeItem = (id) => persist(items.filter((it) => it.id !== id));
  const clearAll = () => persist([]);

  const subtotal = items.reduce((a, p) => a + (p.totalPrice || 0), 0);
  const taxes = subtotal * 0.1;
  const shipping = items.length ? (subtotal > 1000 ? 0 : 20) : 0;
  const total = subtotal + taxes + shipping;

  const handleInputChange = (e) => { const { id, value } = e.target; setFormData((p) => ({ ...p, [id]: value })); };
  const customOnChange = (e) => { const { name, value } = e.target; setFormData((p) => ({ ...p, [name]: value })); };

  const buyNow = () => {
    if (currentUser?.user?.id > 0 && currentUser?.loggedIn) setIsModalOpen(true);
    else navigate("/Login");
  };

  return (
    <div>
      <NavBar />
      <div className="oot-cart">
        <div>
          <h1>Shopping Cart</h1>
          {items.length === 0 ? (
            <div className="oot-cart-list">
              <div className="oot-cart-empty">
                Your cart is empty.<br /><br />
                <button className="oot-btn oot-btn-primary" onClick={() => navigate("/Category")}>Browse products</button>
              </div>
            </div>
          ) : (
            <div className="oot-cart-list">
              {items.map((p) => {
                const src = resolveImg(p.images);
                return (
                  <div className="oot-cart-row" key={p.id}>
                    <div className="oot-cart-thumb">{src ? <img src={src} alt={p.name} /> : <BoxIcon />}</div>
                    <div className="oot-cart-info">
                      <div className="nm">{p.name}</div>
                      <div className="pr">${p.price} each</div>
                      <div className="oot-qty" style={{ marginTop: 8 }}>
                        <button onClick={() => setQty(p.id, p.quantity - 1)}>−</button>
                        <span>{p.quantity}</span>
                        <button onClick={() => setQty(p.id, p.quantity + 1)}>+</button>
                      </div>
                    </div>
                    <div className="oot-cart-line">${(p.totalPrice || 0).toFixed(2)}</div>
                    <button className="oot-cart-rm" title="Remove" onClick={() => removeItem(p.id)}>×</button>
                  </div>
                );
              })}
            </div>
          )}
        </div>

        <div className="oot-summary">
          <h3>Order Summary</h3>
          <div className="oot-sum-row"><span>Subtotal</span><span>${subtotal.toFixed(2)}</span></div>
          <div className="oot-sum-row"><span>Shipping</span><span>{shipping ? `$${shipping.toFixed(2)}` : "Free"}</span></div>
          <div className="oot-sum-row"><span>Taxes (10%)</span><span>${taxes.toFixed(2)}</span></div>
          <div className="oot-sum-total"><span>Total</span><span>${total.toFixed(2)}</span></div>
          <button className="oot-btn oot-btn-primary oot-btn-block oot-btn-lg" style={{ marginTop: 16 }} disabled={!items.length} onClick={buyNow}>Checkout</button>
          {items.length > 0 && <button className="oot-btn oot-btn-ghost oot-btn-block" style={{ marginTop: 10 }} onClick={clearAll}>Clear cart</button>}
          <div className="oot-help">Need help? Call +961 71 032 030<br />Free shipping on orders over $1000.</div>
        </div>
      </div>
      <Footer />
      <ShippingModal
        formData={formData} handleInputChange={handleInputChange} customOnChange={customOnChange}
        onClose={() => setIsModalOpen(false)} isOpen={isModalOpen}
        localStorageData={items} totalPrice={total} shipping={shipping} taxes={taxes}
      />
    </div>
  );
};

export default ShoppingCart;
